import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter,
   Input, OnChanges, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'axis-list',
  templateUrl: './list.component.html',
  host: { class: 'axis-upload-list' }
})
export class ListComponent
  implements AfterViewInit, OnChanges, AfterViewChecked {
  @Input() changeDetect: number;
  @Input() content: string;
  @Input() axisIncludeComponent: any;
  @Input() context: any;
  @Input() imagePreview = false;
  @Input() isOwnRepeater = false;
  @Input() list: Array<any>;
  @Output() changeValue: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowIndexonClickEmitter: EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren('rowcontent', { read: ElementRef })
  rowcontentRefs: QueryList<ElementRef>;
  @ViewChildren('row', { read: ViewContainerRef })
  rowRefs: QueryList<ViewContainerRef>;
  @ViewChild('repeaterWrapper', { read: ViewContainerRef })
  parentwrapperRef: ViewContainerRef;
  @ViewChild('repeaterWrapper1', { read: ElementRef })
  parentwrapperRef1: ElementRef;
  public componentRef: Array<any> = new Array<any>();
  public componentRef1;
  public currObj: any;
  public isAfterviewinit = false;
  public isRendered = false;
  constructor(
    private resolver: ComponentFactoryResolver,
    private _ChangeDetectorRef: ChangeDetectorRef ) {}

  ngAfterViewInit() {
    this.updateTemplate();
    this.isAfterviewinit = true;
  }
  ngAfterViewChecked() {
    if (this.isRendered) {
      this.updateTemplate();
      this.isRendered = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['list'].currentValue && this.isAfterviewinit) {
      this.isRendered = true;
    }
  }

  updateTemplate() {
    if (!this.isOwnRepeater && this.list && this.list.length > 0) {
      if (this.axisIncludeComponent) {
        this.deleteListItems();
        this.instantiateExternalListItem(0);
      } else {
        this.instantiateContentListItem(0);
      }
    }
    if (this.isOwnRepeater) {
      if (this.axisIncludeComponent) {
        const factory = this.resolver.resolveComponentFactory(
          this.axisIncludeComponent
        );
        this.componentRef1 = this.parentwrapperRef.createComponent(factory);
        this.componentRef1.instance.componentRef = this;
        this.parentwrapperRef1.nativeElement.appendChild(
          this.componentRef1.location.nativeElement
        );
        if (!this._ChangeDetectorRef['destroyed']) {
          this._ChangeDetectorRef.detectChanges();
        }
      }
    }
  }

  instantiateContentListItem(currIndex: number) {
    if (this.rowcontentRefs) {
      this.rowcontentRefs.toArray()[
        currIndex
      ].nativeElement.innerHTML = this.content;
      currIndex++;
      if (currIndex <= this.rowcontentRefs.toArray().length - 1) {
        this.instantiateContentListItem(currIndex);
      } else {
        return;
      }
    }
  }

  instantiateExternalListItem(currIndex: number) {
    if (this.rowRefs) {
      this.currObj = this.list[currIndex];
      const factory = this.resolver.resolveComponentFactory(
        this.axisIncludeComponent
      );
      this.componentRef[currIndex] = this.rowRefs
        .toArray()
        [currIndex].createComponent(factory);
      this.componentRef[currIndex].instance.data = this.currObj;
      this.componentRef[currIndex].instance.componentRef = this;
        this.componentRef.forEach(element => {
        if (element && element.instance && element.instance.valueChange) {
          element.instance.valueChange.subscribe(x => {
            this.changeValue.emit();
          });
        }
        });
      this.rowcontentRefs['_results'][currIndex].nativeElement.appendChild(
        this.componentRef[currIndex].location.nativeElement
      );
      if (!this._ChangeDetectorRef['destroyed']) {
        this._ChangeDetectorRef.detectChanges();
      }
      currIndex++;
      if (currIndex <= this.rowRefs.toArray().length - 1) {
        this.instantiateExternalListItem(currIndex);
      } else {
        return;
      }
    }
  }

  deleteListItems() {
    for (let i = 0; i < this.componentRef.length; i++) {
      if (this.componentRef[i]) {
        this.componentRef[i].destroy();
      }
    }
  }

  onDelete(data: any) {
    this.deleteEmitter.emit(data);
  }

  itemClick(event, data) {
    event.preventDefault();
    this.rowIndexonClickEmitter.emit(data);
  }
}
